import { Button } from 'antd'

import { ContainerModal, Content } from './styles'
import DeleteApprovalModalHook from './DeleteApprovalClaimModal.hook'

export default function DeleteApprovalClaimModal() {
  const {
    deleteClaimApprovalModal,
    handleSetDeleteApprovalModal,
    onCancelModal,
    fullname,
    isPendingApproval,
  } = DeleteApprovalModalHook()

  return (
    <ContainerModal
      open={deleteClaimApprovalModal.open}
      closable={false}
      width={350}
      onCancel={() => onCancelModal()}
      onOk={() => handleSetDeleteApprovalModal()}
      centered
      footer={[
        <Button onClick={onCancelModal} loading={isPendingApproval} disabled={isPendingApproval}>
          ยกเลิก
        </Button>,
        <Button
          type="primary"
          danger
          onClick={handleSetDeleteApprovalModal}
          loading={isPendingApproval}
          disabled={isPendingApproval}
        >
          ลบ
        </Button>,
      ]}
    >
      <b>คุณต้องการลบผู้อนุมัติ</b>
      <Content>
        คุณแน่ใจหรือไม่ที่จะทำการลบผู้อนุมัติ
        <br />“{fullname}”
      </Content>
    </ContainerModal>
  )
}
